module.exports = __webpack_public_path__ + "img/icon6.2383d302.svg";